'use client';
import { useState, useEffect } from 'react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { LaunchListPanel } from './LaunchListPanel';

function LaunchListPanelOpenerInner({ keyId }: { keyId: string }) {
  const router = useRouter();
  const pathname = usePathname();
  const sp = useSearchParams();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sp.get('waitlist') === '1' || sp.get('panel') === 'waitlist') setOpen(true);
  }, [sp]);

  const handleClose = () => {
    setOpen(false);
    const next = new URLSearchParams(sp.toString());
    next.delete('waitlist'); next.delete('panel');
    const qs = next.toString();
    router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false });
  };

  return <LaunchListPanel open={open} onClose={handleClose} keyId={keyId} />;
}

export function LaunchListPanelOpener({ keyId = 'SWiZWj' }: { keyId?: string }) {
  return <LaunchListPanelOpenerInner keyId={keyId} />;
}